import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';

export default function Notes() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      <main className="pt-32 pb-20">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Page Title */}
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-3">
              Notes
            </h1>
            <p className="text-pink-500 text-xl">注意事項</p>
            <p className="text-gray-600 mt-4">
              安心してご利用いただくために、以下の内容をご確認ください♡
            </p>
          </div>

          {/* Anti-Social Forces */}
          <section className="mb-12">
            <div className="bg-gradient-to-br from-pink-50 to-purple-50 rounded-2xl p-8 md:p-10">
              <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
                <i className="ri-shield-check-line text-pink-500 mr-3 text-3xl"></i>
                反社会的勢力の排除
              </h2>
              <div className="space-y-4 text-gray-700">
                <div className="flex items-start space-x-3">
                  <i className="ri-checkbox-circle-fill text-pink-500 text-xl flex-shrink-0 mt-1"></i>
                  <p>当店は反社会的勢力との一切の関係を遮断し、取引を行いません。</p>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-checkbox-circle-fill text-pink-500 text-xl flex-shrink-0 mt-1"></i>
                  <p>不当な要求に対しては毅然とした対応を行います。</p>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-checkbox-circle-fill text-pink-500 text-xl flex-shrink-0 mt-1"></i>
                  <p>必要に応じて外部専門機関と連携し、適切に対処いたします。</p>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-checkbox-circle-fill text-pink-500 text-xl flex-shrink-0 mt-1"></i>
                  <p>反社会的勢力への資金提供は一切行いません。</p>
                </div>
              </div>
            </div>
          </section>

          {/* About Treatment */}
          <section className="mb-12">
            <div className="bg-white border-2 border-pink-200 rounded-2xl p-8 md:p-10">
              <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
                <i className="ri-heart-pulse-line text-pink-500 mr-3 text-3xl"></i>
                施術について
              </h2>
              <div className="space-y-4 text-gray-700">
                <p className="leading-relaxed">
                  当店のサービスは、リラクゼーションを目的としたマッサージです。医療行為ではございませんので、あらかじめご了承ください。
                </p>
                <p className="leading-relaxed">
                  心身の疲れを癒し、リフレッシュしていただくことを目的としております♡
                </p>
              </div>
            </div>
          </section>

          {/* Usage Restrictions */}
          <section className="mb-12">
            <div className="bg-gradient-to-br from-pink-50 to-purple-50 rounded-2xl p-8 md:p-10">
              <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
                <i className="ri-error-warning-line text-pink-500 mr-3 text-3xl"></i>
                ご利用を控えていただくケース
              </h2>
              <div className="space-y-3 text-gray-700">
                <div className="flex items-start space-x-3">
                  <i className="ri-close-circle-fill text-pink-400 text-xl flex-shrink-0 mt-1"></i>
                  <p>泥酔状態の方</p>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-close-circle-fill text-pink-400 text-xl flex-shrink-0 mt-1"></i>
                  <p>持病をお持ちの方（事前にご相談ください）</p>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-close-circle-fill text-pink-400 text-xl flex-shrink-0 mt-1"></i>
                  <p>発熱や感染症の症状がある方</p>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-close-circle-fill text-pink-400 text-xl flex-shrink-0 mt-1"></i>
                  <p>手術直後の方</p>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-close-circle-fill text-pink-400 text-xl flex-shrink-0 mt-1"></i>
                  <p>炎症や怪我のある方</p>
                </div>
              </div>
              <p className="text-sm text-gray-600 mt-6">
                ※ご不明な点がございましたら、事前にお問い合わせください。
              </p>
            </div>
          </section>

          {/* Prohibited Actions */}
          <section className="mb-12">
            <div className="bg-white border-2 border-pink-200 rounded-2xl p-8 md:p-10">
              <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
                <i className="ri-forbid-line text-pink-500 mr-3 text-3xl"></i>
                禁止事項
              </h2>
              <div className="space-y-4 text-gray-700">
                <div className="bg-pink-50 rounded-xl p-4">
                  <h3 className="font-semibold text-gray-800 mb-2">セラピストへの接触強要</h3>
                  <p className="text-sm">セラピストへの不適切な接触や要求は固くお断りいたします。</p>
                </div>
                <div className="bg-pink-50 rounded-xl p-4">
                  <h3 className="font-semibold text-gray-800 mb-2">盗撮・録音等</h3>
                  <p className="text-sm">無断での撮影、録音、録画は一切禁止です。</p>
                </div>
                <div className="bg-pink-50 rounded-xl p-4">
                  <h3 className="font-semibold text-gray-800 mb-2">性的サービスの要求</h3>
                  <p className="text-sm">性的なサービスの要求は固くお断りいたします。SNSの体験談等を理由とした要求も同様です。</p>
                </div>
                <div className="bg-pink-50 rounded-xl p-4">
                  <h3 className="font-semibold text-gray-800 mb-2">メニュー外の要求</h3>
                  <p className="text-sm">メニューに記載のないサービスの要求はご遠慮ください。</p>
                </div>
                <div className="bg-pink-50 rounded-xl p-4">
                  <h3 className="font-semibold text-gray-800 mb-2">スカウト・引き抜き行為</h3>
                  <p className="text-sm">セラピストへのスカウト行為や引き抜き行為（SNSを含む）は固く禁止いたします。</p>
                </div>
              </div>
              <p className="text-sm text-pink-600 font-semibold mt-6">
                ※上記に該当する行為が確認された場合、即座にサービスを中止し、今後のご利用をお断りさせていただきます。
              </p>
            </div>
          </section>

          {/* Cancellation Policy */}
          <section className="mb-12">
            <div className="bg-gradient-to-br from-pink-50 to-purple-50 rounded-2xl p-8 md:p-10">
              <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
                <i className="ri-calendar-close-line text-pink-500 mr-3 text-3xl"></i>
                キャンセル・遅刻について
              </h2>
              <div className="space-y-4 text-gray-700">
                <div className="flex items-start space-x-3">
                  <i className="ri-checkbox-circle-fill text-pink-500 text-xl flex-shrink-0 mt-1"></i>
                  <p>キャンセルの際は、必ず事前にご連絡をお願いいたします。</p>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-checkbox-circle-fill text-pink-500 text-xl flex-shrink-0 mt-1"></i>
                  <p>無断キャンセルや直前のキャンセルが続く場合、今後のご予約をお断りする場合がございます。</p>
                </div>
                <div className="flex items-start space-x-3">
                  <i className="ri-checkbox-circle-fill text-pink-500 text-xl flex-shrink-0 mt-1"></i>
                  <p>遅刻された場合、施術時間が短縮となる場合がございます。料金は変わりませんのでご了承ください。</p>
                </div>
              </div>
              <p className="text-sm text-gray-600 mt-6">
                皆様に快適にご利用いただくため、ご理解とご協力をお願いいたします♡
              </p>
            </div>
          </section>

          {/* Valuables */}
          <section className="mb-12">
            <div className="bg-white border-2 border-pink-200 rounded-2xl p-8 md:p-10">
              <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
                <i className="ri-safe-line text-pink-500 mr-3 text-3xl"></i>
                貴重品の管理
              </h2>
              <div className="space-y-4 text-gray-700">
                <p className="leading-relaxed">
                  貴重品はお客様ご自身で管理をお願いいたします。紛失や盗難につきましては、当店では責任を負いかねますので、あらかじめご了承ください。
                </p>
              </div>
            </div>
          </section>

          {/* Disclaimer */}
          <section className="mb-12">
            <div className="bg-gradient-to-br from-pink-50 to-purple-50 rounded-2xl p-8 md:p-10">
              <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
                <i className="ri-information-line text-pink-500 mr-3 text-3xl"></i>
                免責事項
              </h2>
              <div className="space-y-4 text-gray-700">
                <p className="leading-relaxed">
                  施術中または施術後の体調変化につきましては、当店では責任を負いかねます。体調に不安がある方は、事前にご相談ください。
                </p>
                <p className="leading-relaxed">
                  お客様の安全と快適なサービス提供のため、ご理解とご協力をお願いいたします♡
                </p>
              </div>
            </div>
          </section>

          {/* Final Note */}
          <div className="text-center bg-white border-2 border-pink-300 rounded-2xl p-8">
            <p className="text-gray-700 leading-relaxed mb-4">
              以上の内容をご確認いただき、ご同意いただける方のみご利用をお願いいたします。
            </p>
            <p className="text-pink-500 font-semibold">
              皆様に安心してお過ごしいただけるよう、心を込めてサービスを提供いたします✨
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}